import script from "./AuditTrailTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditTrailTable.vue?vue&type=script&setup=true&lang=js"

import "./AuditTrailTable.vue?vue&type=style&index=0&id=e400872c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e400872c"]])

export default __exports__